import { WHY_STATS } from "../../lib/content";
import { Reveal } from "../Reveal";

export const WhyThisMatters = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-softwhite text-forest py-32 sm:py-40 lg:py-48"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-20 sm:mb-28">
          <p className="overline text-earth mb-6">He Aha Ai · Why This Kaupapa Matters</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
            Why This Kaupapa Matters
          </h2>
          <p className="mt-6 text-ink/60 font-light text-lg">
            These numbers do not define our wāhine. They show why different
            pathways matter.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14 lg:gap-10">
          {WHY_STATS.map((s, i) => (
            <Reveal key={i} delay={i * 0.12} testId={`why-stat-${i}`}>
              <div className="border-t border-forest/15 pt-8">
                <p className="font-serif-display text-6xl sm:text-7xl font-light text-earth leading-none">
                  {s.value}
                </p>
                <p className="mt-6 text-forest font-light text-lg leading-relaxed">
                  {s.label}
                </p>
                <p className="mt-3 text-ink/50 font-light text-sm leading-relaxed">
                  {s.why}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-28 sm:mt-36 text-center" y={30}>
          <p className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.2]">
            Potential already exists.
            <br />
            <span className="text-earth italic">Opportunity allows it to grow.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};
